import { SCondition } from '@nestjsx/crud-request';

import { ChallengeFilters } from 'src/models/Challenge';
import { cleanString } from 'src/utils';

export const composeQuerySearch = (
  filters: ChallengeFilters,
  options?: { excludeIds?: string[] },
): SCondition => {
  const conditions: SCondition[] = [{ 'published': { '$eq': true } }];

  if (options?.excludeIds?.length) {
    for (const id of options.excludeIds) {
      conditions.push({ 'id': { '$ne': id } });
    }
  }

  if (filters.coach) {
    conditions.push({
      'coach.id': { '$in': filters.coach }
    });
  }

  if (filters.difficulty) {
    conditions.push({
      'difficulty': { '$in': filters.difficulty }
    });
  }

  if (filters.duration) {
    const durationRanges = filters.duration.map(v => {
      const [min, max] = v.split(',') as [string, string];
      return { 'duration': max === '' ? { '$gte': min } : { '$between': [min, max] } };
    });

    conditions.push({ '$or': durationRanges });
  }

  if (filters.tag) {
    conditions.push({
      'tag.id': { '$in': filters.tag }
    });
  }

  if (filters.phrase) {
    conditions.push({
      'normalizedTitle': { '$contL': cleanString(filters.phrase[0]!) }
    });
  }

  return { '$and': conditions };
};
